export default {
  nav: {
    home: '首页',
    about: '关于我们',
    company: '公司简介',
    companyEn: 'Company Introduction',
    history: '发展历程',
    historyEn: 'Development History',
    leader: '董事长寄语',
    leaderEn: 'Chairman\'s Message',
    honors: '荣誉资质',
    honorsEn: 'Honorary Qualifications',
    projects: '投资项目',
    projectsEn: 'Investment Projects',
    chuxin: '源林为民创业饭堂',
    chuxinEn: 'YUANLIN ENTREPRENEURSHIP RESTAURANT FOR THE PEOPLE',
    hotel: '源林酒店',
    hotelEn: 'Yuanlin Hotel',
    ecopark: '源林生态乐园',
    ecoparkEn: 'Yuanlin Ecological Park',
    agriculture: '源林农业',
    agricultureEn: 'Yuanlin Agriculture',
    food: '源林健康食品项目',
    foodEn: 'Yuanlin Health Food Project',
    industrial: '源林智造产业园',
    industrialEn: 'Yuanlin Intelligent Manufacturing Industrial Park',
    building: '源林综合大楼',
    buildingEn: 'Yuanlin Comprehensive Building',
    yuanlin: '源林壹号',
    yuanlinEn: 'Yuanlin No.1',
    news: '新闻资讯',
    newsEn: 'News',
    charity: '慈善公益',
    charityEn: 'Charity',
    contact: '联系我们',
    contactEn: 'Contact Us',
    message: '在线留言',
    messageEn: 'Online Message',
    jobs: '人才招聘',
    jobsEn: 'Talent Recruitment'
  },
  home: {
    slogan1: '初心不忘，源见未来',
    slogan2: '只有不忘初心，同舟共济，方可成就大业',
    about: '关于源林',
    company: '源林投资（广东）有限公司',
    intro: '源林投资（广东）有限公司是一家成立于2019年的港资企业，总部位于佛山南海九江，投资领域涵盖了酒店、房地产、文旅、产业载体、食品、农业等，致力为经济发展与社会和谐做出积极贡献。\n源林投资聚焦关系国计民生、战略新兴产业等领域，勇当粤港澳大湾区的投资先锋，为加快粤港澳大湾区的发展贡献力量。目前公司投资的项目有：源林为民创业饭堂、源林酒店、源林生态乐园、源林智造产业园、源林综合大楼、源林健康食品、源林壹号、农业项目、养殖业项目和种植业等。\n公司热心于医疗、教育、乡村振兴等公益慈善事业，立足社会、服务社会、回馈社会，践行着企业的社会责任。',
    viewMore: '查看详情',
    scrollDown: 'scroll down',
    skipAnimation: '跳过动画',
    news: '新闻资讯',
    newsTitle: 'News'
  },
  projects: {
    chuxin: {
      title: '源林为民创业饭堂',
      subtitle: 'Yuanlin Entrepreneurship Restaurant For The People',
      desc: '源林为民创业饭堂作为源林投资公司的重点项目，我们以源林优质食材为基础，通过全产业链模式，确保食品的品质与安全，旨在为广大民众提供绿色、健康、舒适的餐饮服务，以推动共同富裕为核心理念，帮助更多的人实现创业梦想。"为民创业"四字体现了董事长关杰初先生想带领大家共同富裕的决心，关杰初先生表示："人生最大的价值不是挣了多少钱，而是帮助了多少人，服务了多少人"。'
    },
    hotel: {
      title: '源林酒店',
      subtitle: 'Yuanlin Hotel',
      desc: '源林酒店雄踞在粤港澳大湾区腹地、世界家具之乡与世界美食之都-佛山，坐落于南海九江镇九江大道，东与顺德区交界，南与江门鹤山市相邻，西与高明区、西樵镇隔西江相望，东北与顺德水道及禅城区南庄镇接轨，融入广佛"1小时交通圈"。占地面积约 11789 平方米，总建筑面积约74196平方米，建筑高度约 150 米，总投资约 6.8 亿。'
    },
    ecopark: {
      title: '源林生态乐园',
      subtitle: 'Yuanlin Ecological Park',
      desc: '源林生态乐园项目，位于鹤山市宅梧镇青年水库区域，面积约11178亩。项目由源林投资公司开发，公司秉承"绿水青山就是金山银山"的发展理念，立足全域旅游格局，对接市场客群需求，以原生态、水资源为特色吸引，融合"花海+森林+滨湖+田园"特色主题，构建与自然无界的"度假梦想地"。'
    },
    agriculture: {
      title: '源林农业',
      subtitle: 'Yuanlin Agriculture',
      desc: '广东源林生态农业发展有限公司以激活土地资源、推动农业现代化、构建绿色农旅产业链为核心理念，致力于复耕复种宅梧镇、开平苍城镇的数千亩撂荒地，通过土地整合、水利设施修复、精细化管理和科技支持，成功复耕并改造了大片农田，显著提高了农业产量和土地利用率。\n源林农业引入绿色种植技术，坚持有机种植和绿色生产，确保农产品质量安全，同时注重特色农旅产品的开发，如亲子农耕体验、农产品采摘等，旨在打造农业与旅游、教育等产业融合发展的新模式，为游客提供丰富多彩的乡村生活体验。未来，源林农业将继续加大投入，推动农业现代化发展，为乡村振兴贡献更多力量。'
    },
    food: {
      title: '源林健康食品项目',
      subtitle: 'Yuanlin Health Food Project',
      desc: '源林健康食品项目地点位于佛山市南海区九江镇临港国际产业社区南鲲大道南侧B1地块，项目总用地约84043㎡（约126亩），总建筑面积达30万㎡，总投资15亿。源林健康食品项目包含中央厨房及配餐中心、净菜及预制菜生产车间、手信及面点生产车间、研发中心、冷链仓库、办公及宿舍、员工食堂及大型地下停车场等功能，此外还规划建设预制菜扩大生产车间、大型冷链仓库、员工培训中心、办公及宿舍、大型地下停车场等。'
    },
    industrial: {
      title: '源林智造产业园',
      subtitle: 'Yuanlin Intelligent Manufacturing Industrial Park',
      desc: '源林智造产业园位于佛山市南海区九江大道临港新区，规划用地面积约86亩，项目总建筑面积约为11万平方米，由佛山市源林智造产业园管理有限公司投资2.6亿元重金打造。源林投资公司依托本土制造产业链优势，将打造成为九江镇首个集智能制造、医卫器械、科技研发、跨境电商、物流仓储、综合配套一体的全新高端产业科技智慧园区。'
    },
    building: {
      title: '源林综合大楼',
      subtitle: 'Yuanlin Comprehensive Building',
      desc: '源林综合大楼项目地块位于广东省佛山市南海区九江镇教育路核心地段，规划用地面积为5076 m²，楼体高度约60米，地上 14层，地下1层，总建筑面积15390m²。 源林综合大楼计划建设成为一座多元化餐饮、娱乐、零售一体化的商业综合楼，打造"便捷、安心、健康、活力"的高品质与创意空间，演绎优质环境，共创造美好生活。'
    },
    yuanlin: {
      title: '源林壹号',
      subtitle: 'Yuanlin No.1',
      desc: '源林壹号位于广东省佛山市南海区九江镇九江大道下西村地段北侧B地块，规划用地面积为25591㎡，总建筑面积约84865㎡，含5栋高度约100米的塔楼，以及沿街商业及公建配套设施，住宅楼地上30层，地下1层，沿街商业及公建配套地上一层。项目运用当代流行的设计手法打造具有前瞻性和艺术性的人居环境，体现人与城市及自然之间的和谐共生理念。'
    }
  },
  news: {
    viewDetail: '查看详细',
    moreNews: '更多新闻'
  },
  footer: {
    copyright: '版权所有 © 2024 源林投资（广东）有限公司',
    icp: '粤ICP备XXXXXXXX号',
    address: '地址：广东省佛山市南海区九江镇九江大道',
    phone: '电话：0757-XXXXXXXX',
    provider: '网站建设：中企动力 中山'
  }
}